import {inject, Injectable} from '@angular/core';
import {ConfigService, RefModelStoreService} from '@q9elements/ui-kit/common';
import {GridFetchParams, GridQuery} from '@q9elements/ui-kit/components';
import {map} from 'rxjs';

import {CodeSearchResultData} from '../models/code-search.model';
import {CodeSearchStoreService} from '../services/code-search-store.service';
import {CodeSearchEntity} from './code-search-entity';

@Injectable()
export class CodeSearchQuery extends GridQuery<CodeSearchEntity> {
  private rmStore = inject(RefModelStoreService);
  private codeSearchStoreService = inject(CodeSearchStoreService);

  override fetchEntities(params: GridFetchParams) {
    const {codeSearchQuery, codeSearchType, codeSearchRmn, codeSearchMetadataTypes} =
      this.codeSearchStoreService.store;
    const refModel = this.rmStore.refModel;
    const rmId = refModel._id;
    const url = `${ConfigService.environment.API_ENDPOINT}/code-search/rm/${rmId}/search`;
    const queryParams: any = {
      skip: params.skip,
      limit: params.take
    };
    const body = {filters: params.filters};

    if (codeSearchType) {
      queryParams.type = codeSearchType;
    }

    if (codeSearchQuery) {
      queryParams.search = codeSearchQuery;
    }

    if (codeSearchRmn) {
      queryParams.rmn = codeSearchRmn;
    }

    if (codeSearchMetadataTypes && codeSearchMetadataTypes.length > 0) {
      queryParams.rmn = codeSearchMetadataTypes;
    }

    if (params.sort?.length) {
      const {dir, field} = params.sort[0];

      queryParams.sort = dir;
      queryParams.sortBy = field;
    }

    return this.http
      .post<{list: CodeSearchResultData[]; total: number}>(url, body, {params: queryParams})
      .pipe(
        map(({list, total}) => {
          const result = this.handleEmptySearchResult(list, length);
          return {
            entities: result.list,
            total: total
          };
        })
      );
  }

  private handleEmptySearchResult(
    list: CodeSearchResultData[],
    total: number
  ): {list: CodeSearchResultData[]; total: number} {
    if (
      list.length === 1 &&
      list[0].matched === 'NOT FOUND' &&
      list[0]?.foundIn.type === 'ZERO RESULTS'
    ) {
      return {list: [], total: 0};
    }
    return {list, total};
  }
}
